$(function () {

    $(".inter-back-to-top").click(function () {
        scrollUp();
        return false;
    });

    function scrollUp() {

        $("html, body").animate(
            {
                scrollTop: 0
            }, {
                duration: 400,
                easing: 'swing'
            });

    }

});